export default "__VITE_ASSET__2a4d786b__"